import React, { useEffect, useRef, useState } from 'react';
import { List } from 'immutable';
import { getClearButtonWrapper, parseRenderOptions } from './utils';
import { FieldWrapper } from './FieldWrapper';
import classNames from 'classnames';

export const PasswordField = ({ focusRef, ...props }) => {
  // Create a local ref to use when focusRef is not provided
  const localFocusRef = useRef();

  const renderOptions = parseRenderOptions(props);
  // Get wrapper information if clear button can be visible
  const {
    Tag,
    props: tagProps,
    content,
  } = getClearButtonWrapper(renderOptions, props);

  // Get the property value to use for focusing the field when it changes
  const focusProperty = props[renderOptions.custom.focusOnPropertyChange];
  // Allow focusing of the field if a focusProperty value exists and is falsy
  const [allowAutoFocus] = useState(
    typeof focusProperty !== 'undefined' && !focusProperty,
  );
  // When the focusProperty changes to truthy, focus this field if it's allowed
  useEffect(() => {
    if (focusProperty && allowAutoFocus) {
      if (!focusRef && typeof localFocusRef?.current?.focus === 'function') {
        localFocusRef.current.focus();
      }
    }
  }, [focusProperty, allowAutoFocus, focusRef]);

  return (
    <FieldWrapper {...props} renderOptions={renderOptions}>
      <Tag {...tagProps}>
        <input
          ref={focusRef || localFocusRef}
          className={classNames('form-control', renderOptions.fieldClassName, {
            'form-control-sm': renderOptions.size === 'sm',
            'is-invalid': renderOptions.hasErrors,
            'has-btn': renderOptions.hasClear && !!props.value,
            'is-empty': !props.value,
          })}
          type="password"
          id={props.id}
          name={props.name}
          value={props.value}
          placeholder={renderOptions.placeholder}
          onBlur={props.onBlur}
          onChange={props.onChange}
          onFocus={props.onFocus}
          disabled={!props.enabled}
          form={props.form}
        />
        {content}
      </Tag>
    </FieldWrapper>
  );
};

PasswordField.defaultProps = {
  errors: List(),
};
